import microuniversoApi from "app/api/microuniversoApi"
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container"
import { ItensOrcamentoContainer } from "app/components/itens-orcamento/ItensOrcamentoContainer"
import { renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact"
import { useAppSelector } from "app/redux/hooks"
import { ControllerLegado } from "app/types/ControllerLegado"
import { WindowMU } from "app/types/WindowMU"
import { tratamentoErroPadrao } from "app/use-cases"
import { registrarPerdaCotacao } from "app/use-cases/orcamento/registrarPerdaCotacao"
import globalMU from "globalMU"
import React, { useCallback, useEffect, useRef, useState } from "react"
import { DadosProdutoSemEstoqueDisponivel } from "../produto-sem-estoque-disponivel/ProdutoSemEstoqueDisponivel"
import { CotacoesPerdidasPorOrcamento, DadosRegistroPerdaCotacao, ListaConcorrentes, ListaMotivos, RegistrarPerdaCotacao } from "./RegistarPerdaCotacao"
const estiloTabela = require('../../../estilos/tabelas.module.scss').default

declare var window: WindowMU

const _PASSOS_BREADCRUMB = ["Itens", "Registrar Perda Cotação"]

export type RegistrarPerdaCotacaoContainerProps = {
    identificadorItemSelecionado?: number
    manterItem?: boolean,
    dadosCotacaoQuantidadePerdida?: DadosProdutoSemEstoqueDisponivel
    editarIndexItens?: number
    quantidadeProduto?: number
    itemOrcamentoController?: ControllerLegado
    perdaTotal?: boolean // 470698
    onVoltar?: () => void
    onVoltarParaEdicaoItens?: () => void
}

export const RegistrarPerdaCotacaoContainer = (props: RegistrarPerdaCotacaoContainerProps) => {

    const identificadorOrcamento = useAppSelector((store) => store.orcamento.IdentificadorOrcamento)
    const [listaMotivos, setListaMotivos] = useState<ListaMotivos[]>([])
    const [listaConcorrentes, setListaConcorrentes] = useState<ListaConcorrentes[]>([])
    const [dadosParaCotacaoPerdidaPorOrcamento, setDadosParaCotacaoPerdidaPorOrcamento] = useState<CotacoesPerdidasPorOrcamento>()
    const [processando, setProcessando] = useState(false)

    const isMounted = useRef(true)
    useEffect(() => () => { isMounted.current = false }, [])

    const dadosParaCotacaoPerdidaPorOrcamentoRef = useRef(dadosParaCotacaoPerdidaPorOrcamento)
    dadosParaCotacaoPerdidaPorOrcamentoRef.current = dadosParaCotacaoPerdidaPorOrcamento

    const onVoltarRef = useRef(props.onVoltar)
    onVoltarRef.current = props.onVoltar

    const atualizarDadosParaCotacaoPerdidaPorOrcamento = useCallback(async () => {
        
        globalMU.blockUI()

        try {
            const resposta = await microuniversoApi.Orcamento.registrarCotacoesPerdidasPorOrcamento(identificadorOrcamento, [props.identificadorItemSelecionado]);

            if (!isMounted.current) return

            if (resposta == null) {
                onVoltarRef.current();
                return
            }

            if (resposta && "HasErrors" in resposta) {
                setDadosParaCotacaoPerdidaPorOrcamento({});
                onVoltarRef.current()

            } else {
                setListaConcorrentes(resposta.Concorrentes)
                setListaMotivos(resposta.Motivos)
                setDadosParaCotacaoPerdidaPorOrcamento(resposta.RegistrarCotacoesPerdidasPorOrcamento)
            }

        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }, [identificadorOrcamento, props.identificadorItemSelecionado]);

    const atualizarMotivos = useCallback(async () => {
        globalMU.blockUI();
        try {
            const motivos = await microuniversoApi.Orcamento.listarMotivos();
            if (!isMounted.current) return
            setListaMotivos(motivos);
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }, []);

    const atualizarConcorrentes = useCallback(async () => {
        globalMU.blockUI();
        try {
            const concorrentes = await microuniversoApi.Orcamento.listarConcorrentes();
            if (!isMounted.current) return
            setListaConcorrentes(concorrentes);
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }, []);

    const onRegistrarPerdaCotacao = useCallback(async (registroPerdaCotacao: DadosRegistroPerdaCotacao, manterItemNoOrcamento: boolean) => {
        
        globalMU.blockUI();
        globalMU.blockScreen( { message: "Registrando perda de cotação..." } );
        try {
            setProcessando(true)
            await registrarPerdaCotacao({
                ItenSelecionados: [props.identificadorItemSelecionado],
                ManterItem: registroPerdaCotacao.Quantidade == dadosParaCotacaoPerdidaPorOrcamentoRef.current?.Quantidade 
                        ? manterItemNoOrcamento : true,
                PerdaCotacaoTodosItens: props.perdaTotal, // 470698
                ...registroPerdaCotacao
            })

            renderizarComponentReact(<ItensOrcamentoContainer />, "conteudo-pagina", true)

        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI();
            globalMU.unblockScreen();
            setProcessando(false)
        }
    }, [props.identificadorItemSelecionado]);


    useEffect(() => {
        Promise.all([
            atualizarMotivos(),
            atualizarConcorrentes(),
            atualizarDadosParaCotacaoPerdidaPorOrcamento()
        ])
    }, [atualizarMotivos, atualizarConcorrentes, atualizarDadosParaCotacaoPerdidaPorOrcamento])

    const onBotaoVoltarClicado = useCallback(() => {
        onVoltarRef.current()
    }, [])

    const onPassoSelecionado = useCallback((passo: string) => {
        if (passo.toUpperCase() == "Editar itens".toUpperCase()) {
            props.onVoltarParaEdicaoItens()
        }

        if (passo.toUpperCase() == "Produto Sem Estoque Disponível".toUpperCase()) {
            onVoltarRef.current()
        }

        if (passo.toUpperCase() == "Itens".toUpperCase()) {
            renderizarComponentReact(<ItensOrcamentoContainer />, "conteudo-pagina", true)
        }
    }, [props.onVoltarParaEdicaoItens])

    return ( // atenção no editar itens, se o parametro ACEITAR_PRODUTO_SEM_ESTOQUE != S é possivel gerar cotacao perdida por lá
        <>

            <Breadcrumb2Container
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                id="RegistrarPerdaCotacaoBreadcrumb"
                onBotaoVoltarClicado={onBotaoVoltarClicado}
                passos={_PASSOS_BREADCRUMB}
                onPassoSelecionado={onPassoSelecionado}
            />

            <br />


            <RegistrarPerdaCotacao
                perdaTotal={props.perdaTotal} // 470698
                cotacoesPerdidasPorOrcamento={dadosParaCotacaoPerdidaPorOrcamento}
                listaMotivos={listaMotivos}
                listarConcorrentes={listaConcorrentes}
                manterItem={props.manterItem}
                onRegistrar={onRegistrarPerdaCotacao}
                quantidadeProduto={props.quantidadeProduto}
                identificadorItem={props.identificadorItemSelecionado}
                processando={processando}
            />
        </>
    )
}